import {MBranch} from '../../../service/m-branch/model/m-branch';
import {MSupplier} from '../../../master-files/m-supplier/model/m-supplier';
import {TGrnItem} from './t-grn-item';

export class TGrn {

  indexNo: number;
  branch: MBranch;
  supplier: MSupplier;
  transactionNumber: number;
  transactionDate: string;
  refNumber: string;
  isNbt: boolean = false;
  nbt: number = 0;
  nbtValue: number = 0;
  isVat: boolean = false;
  vat: number = 0;
  vatValue: number = 0;
  creditPeriod: number = 0;
  totalItemQty: number = 0;
  totalPrice: number = 0;
  totalDiscountValue: number = 0;
  totalNetAmount: number = 0;
  totalFinalAmount: number = 0;
  status: string;
  transactionType:string;
  tGrnItemList: TGrnItem [] = [];
}



// WEBPACK FOOTER //
// ./src/app/view/transactions/t-grn/model/t-grn.ts